import { type ReactNode } from 'react';
import { emitWarningToast } from '@adv-frontend/toast';
import { warningQueue } from './queues';

export const showWarning = (content: ReactNode) => {
    const id = emitWarningToast(content, { hasClose: true });

    warningQueue(id);

    return id;
};
